import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LPBgArrow',
  props: {
  isDownwards: {
    type: Boolean,
    default: false
  },
  isUpwards: {
    type: Boolean,
    default: false
  },
  isDarker: Boolean
},
  setup(__props) {

const props = __props;



const { isDownwards, isUpwards, isDarker } = toRefs(props);

const viewBox = computed(() => {
  if (isDownwards.value || isUpwards.value) {
    return '0 0 192 135';
  }
  return '0 0 135 192';
});

const width = computed(() => {
  if (isDownwards.value || isUpwards.value) {
    return 192;
  }
  return 135;
});

const height = computed(() => {
  if (isDownwards.value || isUpwards.value) {
    return 135;
  }
  return 192;
});

const transform = computed(() => {
  if (isDownwards.value) {
    return 'translate(192, 0) rotate(90, 0, 0)';
  }
  if (isUpwards.value) {
    return 'translate(0, 135) rotate(-90, 0, 0)';
  }
  return '';
});

const fill = computed(() => {
  if (isDarker.value) {
    return '#F1F2F4';
  }
  return '#F2F3F5';
});


return { __sfc: true,props, isDownwards, isUpwards, isDarker, viewBox, width, height, transform, fill }
}

})